import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_IDENTITY_MS_BASE_URL
})

const CoreAPI = axios.create({
  baseURL: process.env.REACT_APP_CORE_MS_BASE_URL
})


export const createContactRequest = (form) => API.post("web/v1/contact-requests", form);

export const getConversionRates = (query) => CoreAPI.get(`web/v1/int-cc/rates/detailed-for-converter?${query}`);

export const verifyCheque = (form) => CoreAPI.post("web/v1/cheque/verify", form);

export const createDBEWaitlistEntry = (form) => API.post("web/v1/dbe-waitlist", form);